// DS: DS6.1 - Checkbox Semantics
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import Checkbox from '../../../../Checkbox';
import { setRefs } from '../../../../../utils/refHelpers';
import { useListItem } from '../../common';
import ListItemContent from '../../legos/ListItemContent';
import s from './ListItemCheckbox.scss';
const ListItemCheckbox = (unfilteredProps)=>{
    const _useListItem = useListItem(unfilteredProps), { rootProps: { className , innerRef , checked , name , value , controlAlignment ='top'  } , contentProps , ref  } = _useListItem, rest = _object_without_properties(_useListItem.rootProps, [
        "className",
        "innerRef",
        "checked",
        "name",
        "value",
        "controlAlignment"
    ]);
    return(// TODO: Still not a11y, can't activate the checkbox with keyboard. Need to refactor base checkbox component
    /*#__PURE__*/ React.createElement(Checkbox, _extends({
        // TODO: Add role="checkbox"? Use da-a11y checkbox?
        "aria-checked": checked,
        className: c(s['checkbox'], controlAlignment === 'center' && s['align-items-center'], className),
        // TODO: Refactor away the need to unset the default checkbox font?
        labelClassName: s['label-unset-font'],
        isChecked: checked,
        id: name,
        innerRef: (node)=>setRefs([
                ref,
                innerRef
            ], node)
    }, rest), /*#__PURE__*/ React.createElement(ListItemContent, _extends({}, contentProps))));
};
ListItemCheckbox.displayName = 'ListItemCheckbox';
export default ListItemCheckbox;
